export const navLinkData = [
    {
        id: 1001,
        title: "Home",
        link: "home"
    },
    {
        id: 1002,
        title: "Services",
        link: "services"
    },
    {
        id: 1003,
        title: "Projects",
        link: "projects"
    },
    {
        id: 1004,
        title: "Resume",
        link: "resume"
    },
    {
        id: 1005,
        title: "Contact",
        link: "contact"
    }
]